import { render, staticRenderFns } from "./WaterMarkLayer.vue?vue&type=template&id=47440066&"
import script from "./WaterMarkLayer.vue?vue&type=script&lang=js&"
export * from "./WaterMarkLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports